"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcRoadConstructionPrice = void 0;
/**
 * "道路工事のみ、すべての合計に「法定福利費」と「諸経費」を加えた金額で見積もりが作られるようにしてください。
 * 法定福利費: （すべての製品の合計×15％）×13％
 * 諸経費: すべての製品の合計×15％
 */
var calcRoadConstructionPrice = function (totalPrice) {
    // 法定福利費（(totalPrice × 15%) × 13%）
    var statutoryWelfareCost = totalPrice * 0.15 * 0.13;
    // 諸経費（totalPrice × 15%）
    var miscellaneousExpenses = totalPrice * 0.15;
    // 合計金額に法定福利費と諸経費を加える(小数点は切り上げ)
    return Math.ceil(totalPrice + statutoryWelfareCost + miscellaneousExpenses);
};
exports.calcRoadConstructionPrice = calcRoadConstructionPrice;
